module.exports = __webpack_public_path__ + "img/welcome-image.6467a344.svg";